module.exports = "/_next/static/images/59dca58ddb3bef5844c6e3231484b691-graph.svg";